import script from "./AssigneeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeSelector.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeSelector.vue?vue&type=style&index=0&id=a812fc20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a812fc20"]])

export default __exports__